/**
 * Created by Olga on 13.10.2026
 */

const CollectibleLastStageHintLogic = {
    type: "collectible_last",
    priority: 5,
    findMove: function () {
        if (!Merge2.current || !Merge2.current.isGameMode() || Merge2.current.field.countEmptySlots() > 0) {
            return;
        }

        const units = Merge2.current.field.listAvailableUnits((unit) => unit.findComponent(Collectible) && !unit.isGrounded() && unit.onGetView() && unit.isLast());
        if (!units.length) {
            return;
        }

        const unit = units[0];

        return {
            type: CollectibleLastStageHintLogic.type,
            delay: 3000,
            target: unit.onGetView(),
            glow: true
        };
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(CollectibleLastStageHintLogic);
